<template>
  <v-app-bar style="background-color: #626262">
    <v-container fluid class="py-0 px-2 px-md-4">
      <v-row no-gutters justify="space-between" align="center">
        <v-col v-if="showFilterButton">
          <v-btn icon class="px-0" color="white" @click.stop="() => emit('menuClick')">
            <v-icon size="large" :icon="mdiTune"></v-icon>
          </v-btn>
        </v-col>

        <v-col class="flex-grow-0">
          <v-btn
            variant="text"
            :href="'https://gendib.wsl.ch/en/'"
            target="_blank"
            class="navbar-link text-h6 text-md-h5 px-0"
          >
            GenDiB
          </v-btn>
        </v-col>

        <v-col cols="6" class="px-4 px-md-0 metadata-title text-caption text-md-body-1">
          Swiss Database of Genetic Diversity Studies on Wild Populations
        </v-col>

        <v-col class="flex-grow-0">
          <v-img :src="iconPath" contain class="my-icon"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script setup lang="ts">
import iconPath from '../../wsl_icon_new.jpeg'
import { useDisplay } from 'vuetify'
import { mdiTune } from '@mdi/js'
import { computed } from 'vue'

const emit = defineEmits(['menuClick'])

const showFilterButton = computed(() => {
  const display = useDisplay();
  return display.smAndDown.value;
})
</script>

<style scoped>
.navbar-link {
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: white;
  text-decoration: none;
  text-transform: none;
}

.navbar-link:hover {
  color: #ebe3a8;
  text-decoration: none;
}
.my-icon {
  height: 40px;
  width: 40px;
}
.metadata-title {
  font-family: 'Roboto', sans-serif;
  color: white;
  overflow: visible;
  white-space: normal;
}
</style>
